import { useSearchspringSearchContext } from "@app/scripts/providers/searchspring"
import { useSearchspringOption } from "./use-searchspring-option"
import { useMemo } from "react"

export function useSearchspringPage() {
  const { response, refine } = useSearchspringSearchContext()

  const page = useSearchspringOption("page", {
    defaultValue: 1,
    syncWithURL: true,
  })

  const isLastPage = useMemo(() => {
    if (!response) return true
    const lastPage = response.pagination.totalPages

    if (!page) return lastPage === 1
    return typeof page === "number" && page >= lastPage
  }, [response, page])

  const isFirstPage = useMemo(() => {
    return !page
  }, [page])

  function handleNextPage() {
    const nextPage = typeof page === "number" ? page + 1 : 2
    refine("page", nextPage)
  }

  function handlePrevPage() {
    const prevPage = typeof page === "number" ? page - 1 : 1
    refine("page", prevPage)
  }

  return {
    pagination: response?.pagination,
    isLastPage,
    isFirstPage,
    handleNextPage,
    handlePrevPage,
  }
}
